import { useState } from 'react';
import Styles from './NSBarAction.module.css';
import { NSMenuActionProps, NSMenuAction } from './NSMenuAction';
import { NSDialogInfo } from './NSDialogInfo';
import { IBaseComponentProps } from '../main';

export interface NSBarActionProps extends IBaseComponentProps
{
	title?: string;
	description?: string;
	menus?: { [group: string]: NSMenuActionProps[] };
}

export interface NSBarActionState
{
	show: boolean
}

export function isValidMenu(menus?: { [group: string]: NSMenuActionProps[] }) 
{
	let ans = false;
	if (menus)
		Object.keys(menus).forEach(menu =>
		{
			if (menus[menu].length > 0)
				ans = true;
		});
	return ans;
}

export function isValidAction(props?: NSBarActionProps)
{
	if (props)
		if (props.title?.trim() || props.description?.trim() || isValidMenu(props.menus))
			return true;
	return false;
}

export function NSBarAction(props: NSBarActionProps)
{
	const [state, setState] = useState<NSBarActionState>({
		show: false
	})

	return (
		<>
			<div
				id={props.id}
				className={`${Styles.ns_bar_action_holder} ${props.classList?.join(" ") ?? ""}`}
				style={props.style}
			>
				<div className={`container d-flex justify-content-center justify-content-lg-between align-items-center w-100  ${Styles.ns_bar_action_grant_parent}`}>
					{
						(props.title?.trim() || props.description?.trim()) &&
						<div className={`d-lg-flex ${Styles.ns_bar_action_parent}`}>
							{
								props.title?.trim() &&
								<p className={Styles.ns_bar_action_title}>{props.title}</p>
							}
							{
								props.description?.trim() &&
								<button className={Styles.ns_bar_action_info_container} onClick={() => setState({ show: true })}>
									<img src='https://static.namirasoft.com/image/concept/info/white-blue.svg' alt='info-icon' width={24} height={24} />
									<span> Info </span>
								</button>
							}
							{
								state.show &&
								<NSDialogInfo
									description={props.description}
									title={props.title}
									onClose={() => setState({ show: false })}
									show_as_code={false}
								>
									<></>
								</NSDialogInfo>
							}
						</div>
					}
					{
						props.menus && isValidMenu(props.menus) &&
						<div className={Styles.ns_bar_action_actions_holder}>
							{
								Object.keys(props.menus ?? {}).map((group, index) => <NSMenuAction key={`NSBarAction_NSMenuAction_Key_${index}`} name={group} items={(props.menus ?? {})[group]} />)
							}
						</div>
					}
				</div>
			</div>
		</>
	);
}